import React from 'react';
import { Switch, Route, BrowserRouter as Router } from 'react-router-dom';
import LoginPage from './login/LoginPage';
import ForgotPassword from './login/ForgotPassword';
import Signup from './signup/Signup';
import CreateNewProject from './projects/CreateNewProject';
import WidgetSettings from './projectmgmt/settings/WidgetSettings';
import MainPage from './projectmgmt/MainPage';
import AdvancedCustomSettings from './projectmgmt/settings/AdvancedCustomSettings';
import Test from './projectmgmt/testAndDeploy/Test';
import Alexa from './projectmgmt/testAndDeploy/Alexa';
import Facebook from './projectmgmt/testAndDeploy/Facebook';
import ProjectPlanSettings from './projectmgmt/settings/ProjectPlanSettings';
import AksharMainPage from './aksharUi/AksharMainPage';
import NlpMainPage from './nlpUi/NlpMainPage';
import ASRMainPage from './asrUi/ASRMainPage';
import BotBasedPricing from './projectmgmt/settings/pricingDetails/BotBasedPricing';
import UtteranceBasedPricing from './projectmgmt/settings/pricingDetails/UtteranceBasedPricing';
import FixedMonthlyCostPricing from './projectmgmt/settings/pricingDetails/FixedMonthlyCostPricing';
import ManagePro from './projectmgmt/header/ManagePro'
import Invoices from './projectmgmt/header/Invoices';
import { TermsAndCondition } from './projectmgmt/TermsAndCondition';
import PrivacyPolicy from './projectmgmt/PrivacyPolicy';
import TtsMainPage from './ttsUi/TtsMainPage';
import StsMainPage from './stsUi/StsMainPage';


const Main = () => {
  return (
    <Router basename={window.contextPath}>
      <Switch>
        <Route exact path='/' component={LoginPage}></Route>
        <Route exact path='/login' component={LoginPage}></Route>
        <Route exact path='/test' component={Test}></Route>
        <Route exact path='/alexa' component={Alexa}></Route>
        <Route exact path='/facebook' component={Facebook}></Route>
        <Route path='/signup' component={Signup}></Route>
        <Route path='/forgotpassword' component={ForgotPassword}></Route>
        <Route path='/projects/createNewProject' component={CreateNewProject}></Route>
        <Route path='/settings/WidgetSettings' component={WidgetSettings}></Route>
        <Route path='/projectmgmt' component={MainPage}></Route>
        <Route path='/cloud-akshar' component={AksharMainPage}></Route>
        <Route path='/cloud-nlp' component={NlpMainPage}></Route>
        <Route path='/cloud-asr' component={ASRMainPage}></Route>
        <Route path='/cloud-tts' component={TtsMainPage}></Route>
        <Route path='/cloud-sts' component={StsMainPage}></Route>
        <Route path='/AdvancedCustomSettings' component={AdvancedCustomSettings}></Route>
        <Route path='/project-plan-settings' component={ProjectPlanSettings}></Route>
        <Route path='/manage-projects' component={ManagePro}></Route>
        <Route path='/bot-based-pricing' component={BotBasedPricing}></Route>
        <Route path='/utterance-based-pricing' component={UtteranceBasedPricing}></Route>
        <Route path='/fixed-based-pricing' component={FixedMonthlyCostPricing}></Route>
        <Route path="/invoice" component={Invoices}></Route>
        <Route exact path="/terms-and-condition" component={TermsAndCondition}></Route>
        <Route exact path="/privacy-policy" component={PrivacyPolicy}></Route>
      </Switch>
    </Router>
  );
}
export default Main;


// WEBPACK FOOTER //
// ./src/Main.js